// @flow
import React, {Component} from 'react';
import loadLocaleData from '../../utils/loadLocaleData';
import {IntlProvider} from 'react-intl';
import {formatLocale} from '../../utils/localization';
import withLingua from '../withLingua/withLingua';

import type {LinguaProps} from '../withLingua/withLingua';

type OwnProps = {
    children: any
};

type Props = OwnProps & LinguaProps;

export class IntlWrapper extends Component<Props> {
    constructor(props: Props) {
        super(props);
        loadLocaleData(props.locale);
    }

    render() {
        const {children, messages, locale, isLinguaLoading} = this.props;
        if (isLinguaLoading) {
            return null;
        }
        const intlLocale = formatLocale(locale);
        return (
            <IntlProvider
                locale={intlLocale}
                key={intlLocale}
                messages={messages}
            >
                {children}
            </IntlProvider>
        );
    }
}

export default withLingua({
    namespace: 'traveler/search',
    category: 'messages'
})(IntlWrapper);
